import {RemixBrowser, useLocation, useMatches} from '@remix-run/react'
import * as Sentry from '@sentry/remix'
import {StrictMode, useEffect} from 'react'
// eslint-disable-next-line react/no-deprecated
import {hydrate} from 'react-dom'

import {SENTRY_DSN} from './constants'

if (
  window.ENV?.SENTRY_ENVIRONMENT &&
  ['production', 'staging'].includes(window.ENV.SENTRY_ENVIRONMENT)
) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: window.ENV.SENTRY_ENVIRONMENT,
    release: window.ENV.RELEASE_HASH,
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: window.ENV.SENTRY_TRACES_SAMPLE_RATE,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      /AbortError/,
      /TypeError: Load failed/,
    ],
  })
}

hydrate(
  <StrictMode>
    <RemixBrowser />
  </StrictMode>,
  document,
)
